import React from 'react'
import axios from 'axios'
import { Typography, CircularProgress } from '@material-ui/core'
import AreaNotes from './AreaNotes'
import AssumptionsList from './AssumptionsList'
import QuestionThread from './QuestionThread'
import AreaPhotoGallery from './AreaPhotoGallery'

const AreaWorkspace = ({ areaId, url, user }) => {
  const [area, setArea] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (!areaId) return
    setLoading(true)
    axios.get(`${url}/api/bid-estimation/areas/${areaId}`).then(res => {
      setArea(res.data)
      setLoading(false)
    }).catch(err => {
      console.error('Failed to fetch area:', err)
      setLoading(false)
    })
  }, [areaId])

  if (!areaId) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">Select an area to view details.</Typography>
      </div>
    )
  }

  if (loading || !area) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
        <CircularProgress size={20} />
      </div>
    )
  }

  return (
    <div style={{
      backgroundColor: '#fff', borderRadius: 8,
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: 16
    }}>
      <Typography variant="h6" style={{ fontWeight: 600, fontSize: 16, marginBottom: 12 }}>
        {area.name}
        {area.phase && <span style={{ fontSize: 12, fontWeight: 400, color: '#666', marginLeft: 8 }}>{area.phase}</span>}
      </Typography>

      <AreaNotes
        areaId={area._id}
        initialNotes={area.notes}
        url={url}
        onSaved={(notes) => setArea(prev => ({ ...prev, notes }))}
      />

      <AssumptionsList
        areaId={area._id}
        assumptions={area.assumptions}
        url={url}
        onUpdated={(assumptions) => setArea(prev => ({ ...prev, assumptions }))}
      />

      <QuestionThread
        areaId={area._id}
        questions={area.questions}
        url={url}
        user={user}
        onUpdated={(questions) => setArea(prev => ({ ...prev, questions }))}
      />

      <AreaPhotoGallery areaId={area._id} url={url} />
    </div>
  )
}

export default AreaWorkspace
